module.exports = "/assets/data/9b2b2956e5079fdb174e9f7d093c97be-LL55.data.json";